// extracted by mini-css-extract-plugin
export default {"chooseCat":"style_chooseCat__w44sF","toogle":"style_toogle__wphHg"};